// Star Alliance brand palette — theme constants
// Extracted here so modals can import without circular dependencies.

export const DARK_THEME = {
  black:       "#060912",      // deep navy bg for ambient gradients
  charcoal:    "rgba(18,23,40,0.68)",   // glass card panel
  darkGray:    "rgba(255,255,255,0.05)",// subtle glass input
  medGray:     "rgba(255,255,255,0.08)",// slightly more opaque
  borderGray:  "rgba(255,255,255,0.10)",// glass border
  silver:      "#7A84A0",
  lightSilver: "#BEC5D6",
  white:       "#EEF0F4",
  accent:      "#5B8EFF",
};

export const LIGHT_THEME = {
  black:       "#E8EDF6",       // soft blue-gray bg
  charcoal:    "rgba(255,255,255,0.62)", // glass card
  darkGray:    "rgba(255,255,255,0.50)", // input glass
  medGray:     "rgba(240,242,252,0.60)",
  borderGray:  "rgba(80,100,160,0.28)",  // glass border (slightly blue-tinted)
  silver:      "#64748B",
  lightSilver: "#374151",
  white:       "#0F1117",
  accent:      "#2563EB",
};

export const DARK_STATUS_STYLES = {
  "MONITORING":        { bg: "rgba(30,24,0,0.72)",   border: "rgba(122,106,0,0.75)",  text: "#C8A830", dot: "#C8A830" },
  "SUCCESS":           { bg: "rgba(14,31,16,0.72)",  border: "rgba(46,107,48,0.75)",  text: "#6EC472", dot: "#52B856" },
  "PARTIAL SUCCESS":   { bg: "rgba(30,24,0,0.72)",   border: "rgba(107,90,0,0.75)",   text: "#D4A82A", dot: "#D4A82A" },
  "UNSUCCESSFUL":      { bg: "rgba(32,12,12,0.72)",  border: "rgba(122,38,38,0.75)",  text: "#D46060", dot: "#D46060" },
  "REBOOKED":          { bg: "rgba(14,14,34,0.72)",  border: "rgba(58,58,138,0.75)",  text: "#8A8AE0", dot: "#8A8AE0" },
  "UNABLE TO CONFIRM": { bg: "rgba(30,18,18,0.72)",  border: "rgba(107,48,48,0.75)",  text: "#D48080", dot: "#D48080" },
  "PROTECTED":         { bg: "rgba(12,26,42,0.72)",  border: "rgba(30,80,128,0.75)",  text: "#60A8E0", dot: "#60A8E0" },
  "CONFIRMED":         { bg: "rgba(14,31,16,0.72)",  border: "rgba(46,107,48,0.75)",  text: "#6EC472", dot: "#52B856" },
  "OFFLOADED":         { bg: "rgba(32,12,12,0.72)",  border: "rgba(122,38,38,0.75)",  text: "#D46060", dot: "#D46060" },
  "COMPLETED":         { bg: "rgba(18,18,18,0.72)",  border: "rgba(58,58,58,0.75)",   text: "#888888", dot: "#888888" },
};

export const LIGHT_STATUS_STYLES = {
  "MONITORING":        { bg: "#FEF3C7", border: "#D97706",  text: "#B45309", dot: "#D97706" },
  "SUCCESS":           { bg: "#C8E6C9", border: "#388E3C",  text: "#1B5E20", dot: "#388E3C" },
  "PARTIAL SUCCESS":   { bg: "#FFF176", border: "#F57F17",  text: "#E65100", dot: "#F57F17" },
  "UNSUCCESSFUL":      { bg: "#FFCDD2", border: "#C62828",  text: "#B71C1C", dot: "#C62828" },
  "REBOOKED":          { bg: "#C5CAE9", border: "#303F9F",  text: "#1A237E", dot: "#303F9F" },
  "UNABLE TO CONFIRM": { bg: "#FFCDD2", border: "#E57373",  text: "#B71C1C", dot: "#E57373" },
  "PROTECTED":         { bg: "#BBDEFB", border: "#1565C0",  text: "#0D47A1", dot: "#1565C0" },
  "CONFIRMED":         { bg: "#C8E6C9", border: "#388E3C",  text: "#1B5E20", dot: "#388E3C" },
  "OFFLOADED":         { bg: "#FFCDD2", border: "#C62828",  text: "#B71C1C", dot: "#C62828" },
  "COMPLETED":         { bg: "#EEEEEE", border: "#757575",  text: "#424242", dot: "#757575" },
};
